import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import * as moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class ProfissionalService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getProfissionais(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/profissionais' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getProfissional(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/profissionais/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


	getProfissionalPorUnidade(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/profissionais/buscaPorUnidade/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getProfissionalEdit(clienteId,unidadeId) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/profissionais/buscaProfissionalEdit/' + clienteId + '/' + unidadeId)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


	// alterar dados que serão passados pelo 'data'
	criaProfissional(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/profissionais', {
				profissional_nome: data.profissional_nome,
				tipo_profissional_id: data.tipo_profissional_id,
				profissional_cpf: data.profissional_cpf,
				profissional_rg: data.profissional_rg,
				profissional_email: data.profissional_email,
				profissional_data_nascimento: data.profissional_data_nascimento,
				profissional_foto: data.profissional_foto,
				profissional_telefone_celular: data.profissional_telefone_celular,
				profissional_telefone_residencial: data.profissional_telefone_residencial,
				profissional_situacao: data.profissional_situacao,
				profissional_cnh: data.profissional_cnh,
				profissional_data_vencimento_cnh: data.profissional_data_vencimento_cnh,
				profissional_pontuacao_cnh: data.profissional_pontuacao_cnh,
				profissional_data_criacao: data.usuario_situacao,
				usuario_id: data.usuario_situacao,
				unidade_id: data.usuario_situacao,
				cliente_id: data.usuario_situacao,
				profissional_tipo_cnh: data.profissional_tipo_cnh,
				profissional_matricula: data.profissional_matricula,
				profissional_data_curso: data.profissional_data_curso,
				unidades: data.unidades,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	// alterar dados que serão passados pelo 'data'
	editaProfissional(data) {
		return new Promise((resolve, reject) => {
			let params = {
				profissional_nome: data.profissional_nome,
				tipo_profissional_id: data.tipo_profissional_id,
				profissional_cpf: data.profissional_cpf,
				profissional_rg: data.profissional_rg,
				profissional_email: data.profissional_email,
				profissional_data_nascimento: data.profissional_data_nascimento,
				profissional_foto: data.profissional_foto,
				profissional_telefone_celular: data.profissional_telefone_celular,
				profissional_telefone_residencial: data.profissional_telefone_residencial,
				profissional_situacao: data.profissional_situacao,
				profissional_cnh: data.profissional_cnh,
				profissional_data_vencimento_cnh: data.profissional_data_vencimento_cnh,
				profissional_pontuacao_cnh: data.profissional_pontuacao_cnh,
				profissional_tipo_cnh: data.profissional_tipo_cnh,
				profissional_matricula: data.profissional_matricula,
				profissional_data_curso: data.profissional_data_curso,
				unidades: data.unidades,
			};
			this.http.put(this.url + '/profissionais/' + data.profissional_id, params)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaProfissional(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/profissionais/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


	getCondutoresByUsuarioGrafico(usuario_id, filtro={}){

		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {

			console.log("[getCondutoresByUsuarioGrafico] = ", params)

			this.http.get(this.url + '/profissionais/condutores/' + usuario_id  + '/' + params)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}	

	getCondutoresByUsuario(usuario_id){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/profissionais/condutores/' + usuario_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


	getCondutoresByUsuarioPorUnidade(usuario_id){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/profissionais/condutoresPorUnidade/' + usuario_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getProfissionaisByUsuario(usuario_id){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/profissionais/usuario/' + usuario_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getRelatorioCondutores(usuario_id){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/profissionais/relatorio/' + usuario_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getProfissionaisByUnidades(data){
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/profissionais/unidades', {
				unidades: data.unidades,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	
}
